<!-- Broadened PIP Yes/No Question -->
<radiobutton-question
    *ngIf="showBroadenedPIPYesNo"
    #broadenedPipRadiobutton
    [question]="broadenedPIPYesNo"
    [required]="true"
    (clicked)="broadenedPipSelection()"
    [isFormSubmitted]="isFormSubmitted">
</radiobutton-question>

<!-- Broadened PIP -->
<dropdown-question
    *ngIf="showBroadenedPIP"
    #broadenedPipDropdown
    [question]="broadenedPIP"
    [disabled]="isBroadenedPipDisabled"
    [requiredAmtOrDecline]="broadenedPIP.required"
    [isFormSubmitted]="isFormSubmitted">
</dropdown-question>

<!-- Broadened PIP Deductible-->
<dropdown-question
    *ngIf="showBroadenedPIPDeductible"
    #broadenedPipDeductibleDropdown
    [question]="broadenedPIPDeductible"
    [disabled]="isBroadenedPipDeductibleDisabled"
    [requiredAmtOrDecline]="broadenedPIPDeductible.required"
    [isFormSubmitted]="isFormSubmitted">
</dropdown-question>

<!-- Named Individual -->
<div *ngIf="showBroadenedPIPYesNo && broadenedPIPYesNo?.answer == 'Yes'">
<div *ngFor="let named of ProductModel.AddAnotherNamedIndividual; let i= index;">
    <div class="row mb-1" *ngIf="!named.isDeleted">
        <div class="col-lg-6">
            <label>{{ProductModel?.productDetails?.namedIndividual?.questionLabel}}</label>
            <span *ngIf="ProductModel?.productDetails?.namedIndividual?.required"
                style="color: red;">*</span>
        </div>
        <div class="col-lg-5">
            <input type="text"
                class="{{(isFormSubmitted || dao.isSubmitForm) && (!namedIndividual?.valid || named.Name == null) ? 'form-control validate_error_cls' : 'form-control'}}"
                [required]="ProductModel?.productDetails?.namedIndividual?.required"
                name="namedIndividual{{i}}" #namedIndividual="ngModel"
                id="namedIndividualID_{{i}}" [(ngModel)]="named.Name">
            <span class="validationred"
                *ngIf="(isFormSubmitted || dao.isSubmitForm) && (!namedIndividual?.valid || named.Name == null)">
                {{namedIndividualValidationMessage}}
            </span>
        </div>
        <div class="col-lg-1">
            <span *ngIf="i != 0"><i class="fa fa-trash delete_icon" title="delete"
                    (click)="removeNamedIndividual(i, named.Name)"></i></span>
        </div>
    </div>
</div>                            
<div class="row mb-1" style="margin-right: 1px;">
    <div class="col-lg-12 text-right"
        *ngIf="showBroadenedPIPYesNo && broadenedPIPYesNo?.answer == 'Yes' && getNamedIndividualCount">
        <a style="color: #115740;" (click)="AddNamedIndividual()">Add Another Named
            Individual</a>
    </div>
</div>
</div>

<!-- Broadened PIP Rating Basis  -->
<div *ngIf="!!nfRateBasis && nfRateBasis.enabled && showBroadenedPIPYesNo && broadenedPIPYesNo?.answer == 'Yes'">
    <dropdown-question
        class="row mb-1"
        #nfRateBasisDropdown
        [question]="nfRateBasis"
        [disabled]="true"
        [isFormSubmitted]="isFormSubmitted">
    </dropdown-question>
</div>